export const aiAppsAndAgentsEnabled = {
    'ai-apps-and-agents': {
        LocKey: 'Filter_AIAppsAndAgents',
        Title: 'AI Apps and Agents',
        LongTitle: 'AI Apps and Agents',
        UrlKey: 'ai-apps-and-agents',
        BackendKey: [
            'ai-apps-and-agents',
            'CognitiveServices_MP',
            'All_CognitiveServices_MP',
            'ai-for-business',
            'bot-apps',
            'BotService',
            'bot-services',
            'BusinessRoboticAutomation',
            'business-robotic-process-automation',
            'CognitiveService',
            'cognitiveServices',
            'cognitive-services'
        ],
        SubCategoryDataMapping: {
            'ai-for-business': {
                LocKey: 'Filter_AIApps',
                Title: 'AI Apps',
                LongTitle: 'AI Apps',
                UrlKey: 'ai-for-business',
                BackendKey: [
                    'ai-for-business'
                ]
            },
            'bot-service': {
                LocKey: 'Filter_Agents',
                Title: 'Agents',
                LongTitle: 'Agents',
                UrlKey: 'bot-service',
                BackendKey: [
                    'BotService',
                    'bot-services',
                    'bot-apps'
                ]
            },
            'business-robotic-process-automation': {
                LocKey: 'Filter_ToolsAndConnectors',
                Title: 'Tools And Connectors',
                LongTitle: 'Tools And Connectors',
                UrlKey: 'business-robotic-process-automation',
                BackendKey: [
                    'BusinessRoboticAutomation',
                    'business-robotic-process-automation'
                ]
            },
            'cognitive-service': {
                LocKey: 'Filter_AzureAIFoundryServices',
                Title: 'Azure AI Foundry Services',
                LongTitle: 'Azure AI Foundry Services',
                UrlKey: 'cognitive-service',
                BackendKey: [
                    'CognitiveService',
                    'cognitiveServices',
                    'cognitive-services',
                    'CognitiveServices_MP',
                    'All_CognitiveServices_MP'
                ]
            }
        }
    },
    'ai-plus-machine-learning': {
        LocKey: 'Filter_MachineLearning',
        Title: 'Machine Learning',
        LongTitle: 'Machine Learning',
        UrlKey: 'ai-plus-machine-learning',
        BackendKey: [
            'ArtificialIntelligence',
            'ai-plus-machine-learning',
            'ai-machine-learning',
            'ai-plus-machine-learning-appsource',
            'ai-plus-machine-learning-dynamics',
            'other-ai-plus-machine-learning',
            'AutomatedML',
            'automated-ml',
            'DataLabelling',
            'data-labelling',
            'DataPreparation',
            'data-preparation',
            'KnowledgeMining',
            'knowledge-mining',
            'MlOperations',
            'ml-operations',
            'MachineLearning',
            'ml-service'
        ],
        SubCategoryDataMapping: {
            'automated-ml': {
                LocKey: 'Filter_automated-ml',
                Title: 'Automated ML',
                LongTitle: 'Automated ML',
                UrlKey: 'automated-ml',
                BackendKey: [
                    'AutomatedML',
                    'automated-ml'
                ]
            },
            'data-labelling': {
                LocKey: 'Filter_data-labelling',
                Title: 'Data Labeling',
                LongTitle: 'Data Labeling',
                UrlKey: 'data-labelling',
                BackendKey: [
                    'DataLabelling',
                    'data-labelling'
                ]
            },
            'data-preparation': {
                LocKey: 'Filter_data-preparation',
                Title: 'Data Preparation',
                LongTitle: 'Data Preparation',
                UrlKey: 'data-preparation',
                BackendKey: [
                    'DataPreparation',
                    'data-preparation'
                ]
            },
            'knowledge-mining': {
                LocKey: 'Filter_knowledge-mining',
                Title: 'Knowledge Mining',
                LongTitle: 'Knowledge Mining',
                UrlKey: 'knowledge-mining',
                BackendKey: [
                    'KnowledgeMining',
                    'knowledge-mining'
                ]
            },
            'ml-operations': {
                LocKey: 'Filter_ml-operations',
                Title: 'ML Operations',
                LongTitle: 'ML Operations',
                UrlKey: 'ml-operations',
                BackendKey: [
                    'MlOperations',
                    'ml-operations'
                ]
            },
            'ml-service': {
                LocKey: 'Filter_ml-service',
                Title: 'ML Service',
                LongTitle: 'ML Service',
                UrlKey: 'ml-service',
                BackendKey: [
                    'MachineLearning',
                    'ml-service'
                ]
            }
        }
    }
};
